import { render, staticRenderFns } from "./TalonPopupNew.vue?vue&type=template&id=fd893102"
import script from "./TalonPopupNew.vue?vue&type=script&lang=js"
export * from "./TalonPopupNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports